import {
  Button,
  Radio,
  //   RadioButtonGroup,
  RadioGroup,
  Stack,
  Text,
} from "@chakra-ui/react";
import propTypes from "prop-types";
import React from "react";

const genderOptions: any = {
  default: ["Male", "Female"].map((item) => ({
    label: item,
    value: item.toLowerCase(),
  })),
  children: [
    { label: "Boy", value: "male" },
    { label: "Girl", value: "female" },
  ],
};

// export function DefaultRadio({ options = "default", ...rest }) {
//   return (
//     <RadioGroup spacing="24px" maxW="320px" flex="1" {...rest}>
//       {genderOptions[options].map((gender: any) => (
//         <Radio key={gender.value} value={gender.value}>
//           <Text fontSize="md">{gender.label}</Text>
//         </Radio>
//       ))}
//     </RadioGroup>
//   );
// }

export function DefaultRadio({
  options = "default",
  defaultValue,
  ...rest
}: {
  teacherGenderOptions: Array<any>;
  defaultValue: string;
  [key: string]: any;
}) {
  return (
    <RadioGroup defaultValue={defaultValue}>
      <Stack spacing={4} {...rest}>
        {genderOptions[options].map((gender: any) => (
          <Radio
            key={gender.value}
            value={gender.value}
            borderColor="neutral.500"
          >
            {gender.label}
          </Radio>
        ))}
      </Stack>
    </RadioGroup>
  );
}

export default function GenderField({ options = "default", ...rest }) {
  return null;
  //   return (
  // <RadioButtonGroup
  //   spacing={0}
  //   borderWidth="2xs"
  //   overflow="hidden"
  //   rounded="md"
  //   isInline
  //   {...rest}
  // >
  //   {genderOptions[options].map((gender) => (
  //     <CustomRadio
  //       key={gender.value}
  //       size="lg"
  //       fontSize="md"
  //       width="50%"
  //       fontWeight="normal"
  //       value={gender.value}
  //       icon={gender.value}
  //     >
  //       {gender.label}
  //     </CustomRadio>
  //   ))}
  // </RadioButtonGroup>
  //   );
}

const CustomRadio = React.forwardRef((props: any, ref) => {
  const { isChecked, isDisabled, value, icon, ...rest } = props;
  return (
    <Button
      ref={ref}
      rounded={isChecked ? "inherit" : "none"}
      variant={isChecked ? "outline" : "ghost"}
      _focus={{ outline: "none" }}
      leftIcon={icon}
      colorScheme={isChecked ? "blue" : "gray"}
      aria-checked={isChecked}
      role="radio"
      isDisabled={isDisabled}
      {...rest}
    />
  );
});

GenderField.propTypes = {
  options: propTypes.oneOf(["default", "children"]),
};

export function TeacherGenderField({
  teacherGenderOptions,
  defaultValue,
  isDisabled,
  ...rest
}: {
  teacherGenderOptions: Array<any>;
  defaultValue: string;
  isDisabled?: boolean;
  [key: string]: any;
}) {
  return (
    <RadioGroup
      isDisabled={isDisabled}
      pt={{ base: 3, md: 0 }}
      defaultValue={defaultValue}
    >
      <Stack spacing={4} isInline {...rest}>
        {teacherGenderOptions.map((gender) => (
          <Radio
            key={gender.value}
            value={gender.value}
            borderColor="neutral.500"
          >
            {gender.label}
          </Radio>
        ))}
      </Stack>
    </RadioGroup>
  );
}
